export default function SectionNav({ items }) {
  const go = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const headerH = document.querySelector("header")?.offsetHeight || 80;
    const barH = 56;
    const offset = -(headerH + barH);
    if (window.__lenis) window.__lenis.scrollTo(el, { offset });
    else {
      const y = el.getBoundingClientRect().top + window.scrollY + offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div
      data-testid="section-nav"
      className="sticky top-16 md:top-20 z-30 bg-[#F6F3EB]/95 backdrop-blur-md border-b border-[#D8D4CA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex gap-1 overflow-x-auto py-2.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {items.map((it) => (
            <button
              key={it.id}
              data-testid={`section-nav-${it.id}`}
              onClick={() => go(it.id)}
              className="shrink-0 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.14em] px-3.5 py-2 border border-transparent text-[#4A4D53] hover:text-[#121212] hover:border-[#121212] transition-colors"
            >
              {it.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
